import { useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { JOB_TRACKER_OPENED } from '@lib/enums/localStorageKeys';
import usePrevious from '@lib/hooks/usePrevious';
import useBackgroundJobs from 'components/JobTracker/hooks/useBackgroundJobs';
import DraggableWrapper from './DraggableWrapper';

export default function JobTracker() {
  const [isAccordionOpen, setAccordionOpen] = useLocalStorage(
    JOB_TRACKER_OPENED,
    true,
  );
  const { jobs, removeJobFromList, dismissAll } = useBackgroundJobs();

  const toggleAccordion = () => setAccordionOpen((prevState) => !prevState);

  // Open the accordion whenever a new job appears.
  const prevCount = usePrevious(jobs.length);
  useEffect(() => {
    if (prevCount !== undefined && jobs.length > prevCount) {
      setAccordionOpen(true);
    }
  }, [jobs.length, prevCount, setAccordionOpen]);

  if (!jobs.length) return null;

  return (
    <DraggableWrapper
      jobs={jobs}
      onRemoveJobHandler={removeJobFromList}
      isAccordionOpen={isAccordionOpen}
      toggleAccordion={toggleAccordion}
      onRemoveAllJobIds={dismissAll}
    />
  );
}
